module.exports = __webpack_public_path__ + "static/media/concert9.d28248fb.jpg";